<template>
  <b-form>
    <p class="font-sm"><strong>{{nameLabel}}</strong> and <strong>{{title}} FOResT ID</strong> must be filled out to <strong>Confirm {{title}}</strong>.</p>
    <ValidationObserver ref="observer" slim>
      <b-form-row>
        <b-col cols="12" lg="6">
          <ValidationProvider
            :name="nameLabel"
            rules="required"
            v-slot="{ errors, classes }"
            slim
          >
            <b-form-group :label-for="`${type}-name`">
              <template v-slot:label>
                <span v-if="!optional" class="req-ind">*</span>{{nameLabel}}
              </template>
              <b-form-input
                :id="`${type}-name`"
                :name="`${type}-name`"
                v-model="name"
                :placeholder="helpMessage"
                maxlength="75"
                :class="classes"
                :aria-describedby="$errorsIdString(errors, `${type}-name`)"
                :disabled="mfsAdmin"
              />
              <InputErrors :errors="errors" :errorsIdPrefix="`${type}-name`" />
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col cols="12" lg="6">
          <ValidationProvider
            :name="`${title} FOResT ID`"
            rules="required|min:3"
            v-slot="{ errors, classes }"
            slim
          >
            <b-form-group :label-for="`${type}-forestId`">
              <template v-slot:label>
                <span v-if="!optional" class="req-ind">*</span>{{title}} FOResT ID
              </template>
              <b-form-input
                :id="`${type}-forestId`"
                :name="`${type}-forestId`"
                v-model="forestId"
                placeholder="Enter FOResT ID"
                maxlength="75"
                :class="classes"
                :aria-describedby="$errorsIdString(errors, `${type}-forestId`)"
                :disabled="mfsAdmin"
              />
              <InputErrors :errors="errors" :errorsIdPrefix="`${type}-forestId`" />
            </b-form-group>
          </ValidationProvider>
        </b-col>
      </b-form-row>
      <b-button
        pill
        variant="primary"
        class="my-3 w-100 w-sm-auto"
        @click="submitWrapper"
        :disabled="mfsAdmin" :aria-label="`Confirm ${title}`">
        Confirm {{title}}
      </b-button>
      <div v-if="contactError" class="text-danger">
        {{contactError}}
      </div>
    </ValidationObserver>
  </b-form>
</template>

<script>
import { mapGetters } from 'vuex';
import FormSubmit from '@/mixins/FormSubmit';

export default {
  name: 'FindContactForm',
  mixins: [FormSubmit],
  props: {
    title: {
      type: String,
      default: 'Contact',
      validator(value) {
        return ['Landowner', 'Designated Agent', 'Harvester/Operator', 'Licensed Forester']
          .indexOf(value) !== -1;
      },
    },
    type: {
      type: String,
      default: 'contact',
    },
    contactError: {
      type: String,
      default: null,
    },
    findActionName: {
      type: String,
      default: null,
    },
    optional: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: null,
      forestId: null,
    };
  },
  computed: {
    ...mapGetters('User', ['mfsAdmin']),
    nameLabel() {
      const displayCompany = ['Landowner', 'Harvester/Operator'].indexOf(this.title) !== -1;
      return `${this.title} Last Name${displayCompany ? ' or Company Name' : ''}`;
    },
    helpMessage() {
      let message = 'Enter Name';
      if (['Landowner', 'Harvester/Operator'].indexOf(this.title) !== -1) {
        message = 'Enter Last Name or Company Name';
      }

      if (['Designated Agent', 'Licensed Forester'].indexOf(this.title) !== -1) {
        message = 'Enter Last Name';
      }

      return message;
    },
  },
  methods: {
    async submitWrapper() {
      if (this.mfsAdmin) {
        return true;
      }
      return this.submit(
        this.$refs.observer,
        this.findActionName,
        {
          name: this.name,
          forestId: this.forestId,
        },
      );
    },
  },
};
</script>
